<template>
  <div class="sz-bubble">
    <router-link :to="link" class="disable-text-decoration">
      <v-sheet
        :elevation="isMobile ? 0 : 4"
        class="min-h-60 d-flex align-center justify-space-between px-5"
        :class="{
          'v-sheet-orange-top': highlighted && !isMobile,
          'mobile-sheet': isMobile,
          'v-sheet-rounded': !isMobile,
          'mobile-border': isMobile,
          'mobile-border--highlighted': isMobile && highlighted
        }"
      >
        <p class="f-18 sz-primary-grey--text mb-0 font-weight-medium">
          {{ name }}
        </p>
        <v-icon class="sz-primary-red--text">
          {{ icon }}
        </v-icon>
      </v-sheet>
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { useVuetifyBreakpoints } from '@/composables/useVuetifyBreakpoints'
import type { RouteLocationRaw } from 'vue-router'

type Props = {
  name?: string
  link: RouteLocationRaw
  highlighted?: boolean
  icon?: string
}

withDefaults(defineProps<Props>(), {
  name: '',
  highlighted: false,
  icon: '$chevronRight'
})

const breakpoints = useVuetifyBreakpoints()
const isMobile = breakpoints.smallerOrEqual('md')
</script>

<style scoped lang="scss">
.sz-bubble {
  width: 100%;
  max-width: 460px;
}

.mobile-sheet {
  border-radius: 10px !important;
}

.mobile-border {
  border: 2px solid #414345;

  &--highlighted {
    border-color: #ed1c24;
  }
}
</style>
